import React, { useState } from "react";
import { Button, Spinner, Table } from "react-bootstrap";
import up_down_arrow from "../../../../Assets/svg/up_down_arrow.svg";
import action_icon_1 from "../../../../Assets/svg/tableData/action-icon-1.svg";
import action_icon_2 from "../../../../Assets/svg/tableData/action-icon-2.svg";
import moment from "moment";
import NewRoleModal from "./Modal/NewRole";
import { del } from "../../../../helpers/api_helper";
import toast from "react-hot-toast";
import DeleteConfirmationModal from "../../../../components/DeleteConfirmation";
import { useSelector } from "react-redux";
import useCheckPermission from "../../../../hooks/useCheckPermission";
import Loader from "../../../../components/shared/Loader";

const RoleTable = ({ isLoading, data, fetchRoles }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("edit");
  const [selectedRole, setSelectedRole] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [roleToDelete, setRoleToDelete] = useState(null);

  const hasUpdatePermission = useCheckPermission("subAdmin", "UPDATE");
  const hasDeletePermission = useCheckPermission("subAdmin", "DELETE");

  const handleDelete = async () => {
    try {
      const response = await del(`/roles/${roleToDelete}`);
      if (response.success) {
        toast.success("Role deleted successfully");
        fetchRoles();
      } else {
        toast.error("Failed to delete role");
      }
    } catch (err) {
      console.error("Error deleting role", err);
      toast.error("An error occurred while deleting role");
    } finally {
      setShowConfirm(false);
    }
  };

  const handleEdit = (data) => {
    setSelectedRole(data);
    setModalMode("edit");
    setShowModal(true);
  };

  const confirmDelete = (id) => {
    setRoleToDelete(id);
    setShowConfirm(true);
  };
  return (
    <>
      <DeleteConfirmationModal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        onConfirm={handleDelete}
      />
      <NewRoleModal
        show={showModal}
        onHide={setShowModal}
        handleRefresh={fetchRoles}
        mode={modalMode}
        editRole={selectedRole}
      />
      {isLoading ? (
        <Loader />
      ):(
        <Table responsive>
          <thead>
            <tr>
              <th className="fw-normal border-0">
                Name
                {/* <Button className="border-0 p-0" variant="transparent">
                  Name
                  <span className="icn ms-2">
                    <img src={up_down_arrow} alt="" />
                  </span>
                </Button> */}
              </th>
              <th className="fw-normal border-0">Status</th>
              <th className="fw-normal border-0">
                Created at
                {/* <Button className="border-0 p-0" variant="transparent">
                  Created at{" "}
                  <span className="icn ms-2">
                    <img src={up_down_arrow} alt="" />
                  </span>
                </Button> */}
              </th>
              <th className="fw-normal border-0">Action</th>
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 ? (
                data?.map((data, key) => (
                  <tr key={key}>
                    <td>{data?.name ? data?.name : "-"}</td>
                    <td className="text-capitalize">{data.status}</td>
                    <td>
                      {data?.created_at
                        ? moment(data.created_at).format("DD-MM-YYYY hh:mm A")
                        : "-"}
                    </td>
                    <td>
                      <td>
                        <div className="d-flex align-items-center gap-10">
                          {hasUpdatePermission && <Button
                            // onClick={handleAddUpdate}
                            className="border-0 p-0"
                            variant="transparent"
                            onClick={() => handleEdit(data)}
                          >
                            <img src={action_icon_1} alt="" />
                          </Button>}
                          {hasDeletePermission && <Button
                            className="border-0 p-0"
                            variant="transparent"
                            onClick={() => confirmDelete(data?._id)}
                          >
                            <img src={action_icon_2} alt="" />
                          </Button>}
                        </div>
                      </td>
                    </td>
                  </tr>
                )
              )
              ):(
                <tr>
                  <td colSpan={4} className="text-center">No data found</td>
                </tr>
              )}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default RoleTable;
